import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.addEventListener('turbo:submit-start', this.toggleSubmitButton)
    this.element.addEventListener('turbo:submit-end', this.toggleSubmitButton)
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-start', this.toggleSubmitButton)
    this.element.removeEventListener('turbo:submit-end', this.toggleSubmitButton)
  }

  toggleSubmitButton = (event) => {
    const button = this.element.querySelector('maui-button[type="primary"]')
    button?.toggleAttribute('disabled', event.type === 'turbo:submit-start')
  }
}
